// src/context/WebSocketContext.js
/* eslint-disable */
import React, { createContext, useContext, useRef, useEffect } from 'react';
import { toast } from 'react-hot-toast';
import { useSelector } from 'react-redux';
const WebSocketContext = createContext();
export const useWebSocket = () => useContext(WebSocketContext);

export const WebSocketProvider = ({ children }) => {
  const currentUser = useSelector((state) => state?.user?.user?.user);
    const socketRef = useRef(null);
  useEffect(() => {
    if (!currentUser || currentUser.role !== "Admin") return;
    // Connect WebSocket to your backend
    const wsUrl = `${process.env.REACT_APP_WS_BASE}/ws/notifications/${currentUser.pk}/`;

    // websocket connection 
    socketRef.current = new WebSocket(wsUrl);



    //When WebSocket connects successfully
    socketRef.current.onopen = () => {
      console.log("✅ WebSocket connected");
    };


    //when backend sends message , run everytime a message is received
    socketRef.current.onmessage = (event) => {
      try {

        //convert msg into json
        const message = JSON.parse(event.data);
        console.log("📨 WebSocket message:", message);
        if (message.type === "chat") {
          toast.success(`New Message from ${message.sender_name}`);
        }
      } catch (err) {
        console.error("Error parsing WebSocket message:", err);
      }
    };
    socketRef.current.onerror = (err) => {
      console.error("WebSocket error:", err);
    };


    //user log out , tab closes 
    socketRef.current.onclose = () => {
      console.log("❌ WebSocket disconnected");
    };



    return () => {
      if (socketRef.current) socketRef.current.close();
    };
  }, [currentUser]);
  return (
    <WebSocketContext.Provider value={{}}>
      {children}
    </WebSocketContext.Provider>
  );
};
